import React, { useState } from 'react';
import { ReactComponent as AngleUp } from '../../assets/svg/AngleUp.svg';
import Solution from './Solution';
import { notify } from '../../utils/util';
import CreateEditSolutionModal from './CreateEditSolutionModal';
import ConfirmationModal from '../modals/ConfirmationModal';
import { deleteSolutionById } from '../../server/server';

function ListOfSolutions({ solutions, setSolutions, topicId, reloadTopic }: { solutions: any; setSolutions: any; topicId: any; reloadTopic: any }) {
	const [showSolutions, setShowSolutions] = useState(true);
	const [currentSolution, setCurrentSolution] = useState(null);
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [deleteSolution, setDeleteSolution] = useState(false);
	const [indexForDelete, setIndexForDelete] = useState(-1);

	const addNewSolution = () => {
		const elementId = solutions.find((element: any) => !element.hasOwnProperty('id'));
		if (elementId) {
			notify('You already have one empty solution!');
			return;
		}
		openCreateEditModal(null);
		setSolutions((prev: any) => [...prev, { title: '', imageId: '', audioTitle: '', audioId: '', paragraphs: [{ text: '', order: 1, type: 'TEXT' }] }]);
	};

	const removeSolution = async (index = indexForDelete) => {
		if (!!solutions[index]?.id) {
			const resp = await deleteSolutionById(solutions[index]?.id);
			if (resp.status === 200) {
				reloadTopic();
				notify('The solution has been successfully deleted!');
			} else {
				notify('The solution has not been deleted!');
			}
		} else {
			notify('The solution has been successfully deleted!');
			solutions.splice(index, 1);
		}
	};

	const openCreateEditModal = (state: any) => {
		setCurrentSolution(state);
		setModalIsOpen(true);
	};
	const closeModal = () => {
		setCurrentSolution(null);
		setModalIsOpen(false);
	};
	const openConfirmRemove = (index: number) => {
		setDeleteSolution(true);
		setIndexForDelete(index);
	};
	const closeDeleteSolution = () => {
		setDeleteSolution(false);
	};
	return (
		<div className='flex flex-col flex-1'>
			<div className='p-5 rounded-[10px] border border-primaryViolet'>
				<div className='flex flex-row items-center  mb-2 gap-4'>
					<p className='flex-1 text-left text-primaryViolet text-[20px] leading-6 font-semibold'>List of solutions</p>
					<div className={`${showSolutions ? 'rotate-180' : 'rotate-0'} transition cursor-pointer h-9 w-9 flex items-center justify-center rounded-full border border-greyMedium`} onClick={() => setShowSolutions(!showSolutions)}>
						<AngleUp style={{ color: '#5E639B' }} />
					</div>
				</div>
				{showSolutions && (
					<div>
						{solutions.map((item: any, index: number) => (
							<Solution solution={item} index={index} key={index} openSolution={openCreateEditModal} confirmRemove={openConfirmRemove} />
						))}
						<div className='pointer mt-4 flex w-full items-center justify-center rounded-xl  bg-mudPurple py-4 text-[16px] left-5 font-semibold text-white hover:bg-deepPurple' onClick={() => addNewSolution()}>
							Add solution {solutions.length + 1}
						</div>
					</div>
				)}
			</div>
			<CreateEditSolutionModal modalIsOpen={modalIsOpen} closeModal={closeModal} topicId={topicId} currentSolution={currentSolution} setCurrentSolution={setCurrentSolution} reloadTopic={reloadTopic} />
			<ConfirmationModal modalIsOpen={deleteSolution} closeModal={closeDeleteSolution} confirmation={removeSolution} message={'Do you want to delete this solution?'} subMessage='The solution will be permanently deleted.' />
		</div>
	);
}

export default ListOfSolutions;
